import {UserDefaultAvatar} from "_const";

type Props = {
    url?: string;
    w?: string;
    h?: string;
    style?: React.CSSProperties;
    className?: string;
};

export const Avatar = ({url, w = '150px', h = '150px', style, className}: Props) => {
    const urlAvatar = url ? url : UserDefaultAvatar;

    return <div {...{className}} style={{
        ...style,
        backgroundImage: `url(${urlAvatar})`,
        width: w,
        height: h,
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        borderRadius: '100%',
    }}/>;
}
